/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  GetTransportationSuccessfulActionPayload,
  GetTransportationByIdActionPayload,
  GetTransportationByIdSuccessfulActionPayload,
  GetActiveTransportationWithRelationsByIdActionPayload,
  GetActiveTransportationByIdWithRelationsSuccessfulActionPayload,
  CreateTransportationActionPayload,
  CreateTransportationSuccessfulActionPayload,
  UpdateTransportationActionPayload,
  UpdateTransportationSuccessfulActionPayload,
  DeleteTransportationActionPayload,
  DeleteTransportationSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/transportation-data-store';

/* action types */
export enum ActionTypes {
  InitFetchingActiveTransportationWithRelations = '[TRANSPORTATION] InitFetchingActiveTransportationWithRelations',
  GetTransportation = '[TRANSPORTATION] GetTransportation',
  GetTransportationSuccessful = '[TRANSPORTATION] GetTransportationSuccessful',
  GetTransportationFailure = '[TRANSPORTATION] GetTransportationFailure',
  GetTransportationById = '[TRANSPORTATION] GetTransportationById',
  GetTransportationByIdSuccessful = '[TRANSPORTATION] GetTransportationByIdSuccessful',
  GetTransportationByIdFailure = '[TRANSPORTATION] GetTransportationByIdFailure',
  GetActiveTransportationWithRelationsById = '[TRANSPORTATION] GetActiveTransportationWithRelationsById',
  GetActiveTransportationByIdWithRelationsSuccessful = '[TRANSPORTATION] GetActiveTransportationByIdWithRelationsSuccessful',
  GetActiveTransportationByIdWithRelationsFailure = '[TRANSPORTATION] GetActiveTransportationByIdWithRelationsFailure',
  CreateTransportation = '[TRANSPORTATION] CreateTransportation',
  CreateTransportationSuccessful = '[TRANSPORTATION] CreateTransportationSuccessful',
  CreateTransportationFailure = '[TRANSPORTATION] CreateTransportationFailure',
  UpdateTransportation = '[TRANSPORTATION] UpdateTransportation',
  UpdateTransportationSuccessful = '[TRANSPORTATION] UpdateTransportationSuccessful',
  UpdateTransportationFailure = '[TRANSPORTATION] UpdateTransportationFailure',
  DeleteTransportation = '[TRANSPORTATION] DeleteTransportation',
  DeleteTransportationSuccessful = '[TRANSPORTATION] DeleteTransportationSuccessful',
  DeleteTransportationFailure = '[TRANSPORTATION] DeleteTransportationFailure',
  ResetState = '[TRANSPORTATION] ResetState',
}

/* actions */

export const InitFetchingActiveTransportationWithRelations = createAction(
  ActionTypes.InitFetchingActiveTransportationWithRelations,
);

/* This event gets the all Transportation. */
export const GetTransportation = createAction(ActionTypes.GetTransportation);

/* This event is fired after getting all the Transportation successfully. */
export const GetTransportationSuccessful = createAction(
  ActionTypes.GetTransportationSuccessful,
  props<{ payload: GetTransportationSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the Transportation. */
export const GetTransportationFailure = createAction(
  ActionTypes.GetTransportationFailure,
);

/* This event gets the Transportation by Transportation id. */
export const GetTransportationById = createAction(
  ActionTypes.GetTransportationById,
  props<{ payload: GetTransportationByIdActionPayload }>(),
);

/* This event is fired after getting Transportation by Transportation id successfully. */
export const GetTransportationByIdSuccessful = createAction(
  ActionTypes.GetTransportationByIdSuccessful,
  props<{ payload: GetTransportationByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Transportation by Transportation id. */
export const GetTransportationByIdFailure = createAction(
  ActionTypes.GetTransportationByIdFailure,
);

/* This event gets the active Transportation by Transportation id. */
export const GetActiveTransportationWithRelationsById = createAction(
  ActionTypes.GetActiveTransportationWithRelationsById,
  props<{ payload: GetActiveTransportationWithRelationsByIdActionPayload }>(),
);

/* This event is fired after getting Transportation by Transportation id successfully. */
export const GetActiveTransportationByIdWithRelationsSuccessful = createAction(
  ActionTypes.GetActiveTransportationByIdWithRelationsSuccessful,
  props<{
    payload: GetActiveTransportationByIdWithRelationsSuccessfulActionPayload;
  }>(),
);

/* This event is fired after couldn't get the Transportation by Transportation id. */
export const GetActiveTransportationByIdWithRelationsFailure = createAction(
  ActionTypes.GetActiveTransportationByIdWithRelationsFailure,
);

/* This event creates a Transportation. */
export const CreateTransportation = createAction(
  ActionTypes.CreateTransportation,
  props<{ payload: CreateTransportationActionPayload }>(),
);

/* This event is fired after creating a Transportation successfully. */
export const CreateTransportationSuccessful = createAction(
  ActionTypes.CreateTransportationSuccessful,
  props<{ payload: CreateTransportationSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a Transportation successfully. */
export const CreateTransportationFailure = createAction(
  ActionTypes.CreateTransportationFailure,
);

/* This event updates a Transportation. */
export const UpdateTransportation = createAction(
  ActionTypes.UpdateTransportation,
  props<{ payload: UpdateTransportationActionPayload }>(),
);

/* This event is fired after updating a Transportation successfully. */
export const UpdateTransportationSuccessful = createAction(
  ActionTypes.UpdateTransportationSuccessful,
  props<{ payload: UpdateTransportationSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a Transportation successfully. */
export const UpdateTransportationFailure = createAction(
  ActionTypes.UpdateTransportationFailure,
);

/* This event deletes a Transportation. */
export const DeleteTransportation = createAction(
  ActionTypes.DeleteTransportation,
  props<{ payload: DeleteTransportationActionPayload }>(),
);

/* This event is fired after deleting a Transportation successfully. */
export const DeleteTransportationSuccessful = createAction(
  ActionTypes.DeleteTransportationSuccessful,
  props<{ payload: DeleteTransportationSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a Transportation successfully. */
export const DeleteTransportationFailure = createAction(
  ActionTypes.DeleteTransportationFailure,
);

/* This event resets the Transportation state. */
export const ResetState = createAction(ActionTypes.ResetState);
